import LazyComment from "@/components/Comment/LazyComment";
import { CommentScope } from "@/interfaces/comment.interface";
import styles from "./styles.module.less";

interface IProps {
  fatherId: string;
  loading: boolean;
}

const scope: CommentScope = "all";

const AllComment: React.FC<IProps> = ({ fatherId, loading }) => {
  return (
    <div className={styles.container}>
      <LazyComment fatherId={fatherId} scope={scope} lazyLoading={loading} />
    </div>
  );
};

export default AllComment;
